import BpkIconHotelFlexible from '@skyscanner/backpack-web/bpk-component-icon/lg/hotel-flexible';
import BpkIconPriceTag from '@skyscanner/backpack-web/bpk-component-icon/lg/price-tag';
import BpkIconSearch from '@skyscanner/backpack-web/bpk-component-icon/lg/search';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { TranslationKey } from '@shared/constants/translations';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './ConfidenceMessaging.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

export type ConfidenceMessagingProps = {
  i18n: I18nService;
  dataList: Array<{
    descriptionKey: TranslationKey;
    placeholders: Record<string, string>;
    iconName: 'price-tag' | 'search' | 'hotel-flexible';
  }>;
};

type ConfidenceMessagingIcon =
  ConfidenceMessagingProps['dataList'][number]['iconName'];

const cls = cssModules(STYLES);

const getIconComponent = (iconName: ConfidenceMessagingIcon) => {
  const mapping = {
    'price-tag': BpkIconPriceTag,
    search: BpkIconSearch,
    'hotel-flexible': BpkIconHotelFlexible,
  };
  return mapping[iconName];
};

const ConfidenceMessaging = ({ dataList, i18n }: ConfidenceMessagingProps) => {
  if (!dataList?.length) {
    return null;
  }
  return (
    <div
      className={cls('ConfidenceMessaging')}
      data-testid="confidenceMessaging"
    >
      {dataList.map((item) => {
        const description = i18n.translate(
          item.descriptionKey,
          item.placeholders,
          '@@',
          '@@',
        );
        const Icon = getIconComponent(item.iconName);
        return (
          <div key={item.iconName} className={cls('ConfidenceMessaging__item')}>
            <div className={cls('ConfidenceMessaging__icon')}>
              <Icon />
            </div>
            <div>
              <BpkText
                className={cls('ConfidenceMessaging__description')}
                tagName="p"
                textStyle={TEXT_STYLES.label1}
              >
                {description}
              </BpkText>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default withI18n(ConfidenceMessaging);
